import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { BausteineAnsicht } from "@/components/bausteine/BausteineAnsicht";
import { aktiverBeleg, bausteinAnBeleg, useBausteineFenster } from "@/lib/windowSync";

// Eigenes Bausteine-Fenster (Büro, zweiter Bildschirm): Liste links, Vergleich rechts, Einfügen in den zuletzt aktiven offenen Beleg.
// Dieselbe Ansicht wie in der Leiste und am Handy (components/bausteine/BausteineAnsicht.jsx).
const BausteineFensterPage = () => {
  const [ziel, setZiel] = useState(null);   // { label } des zuletzt aktiven offenen Belegs
  useBausteineFenster();
  // Höhe = Fenster minus Meldeleiste darüber (sonst schiebt die Seite den Kopf aus dem Fenster)
  const wurzel = useRef(null);
  const [hoehe, setHoehe] = useState(null);
  useEffect(() => {
    const f = () => { if (wurzel.current) setHoehe(Math.max(200, window.innerHeight - wurzel.current.getBoundingClientRect().top - window.scrollY)); };
    f();
    window.addEventListener("resize", f);
    const t = setInterval(f, 1500);   // Meldeleiste kann später erscheinen
    return () => { window.removeEventListener("resize", f); clearInterval(t); };
  }, []);
  useEffect(() => {
    let aus = false;
    const frage = async () => { const z = await aktiverBeleg(); if (!aus) setZiel(z); };
    frage();
    const t = setInterval(frage, 2000);
    return () => { aus = true; clearInterval(t); };
  }, []);

  const einfuegen = async (block, positionen) => {
    const ok = await bausteinAnBeleg(block, positionen);
    if (ok) toast.success(`Baustein „${block.name}“ eingefügt in ${ziel?.label || "den Beleg"}`);
    else toast.warning("Kein Beleg offen – bitte zuerst ein Angebot, eine Auftragsbestätigung oder eine Rechnung öffnen.", { duration: 8000 });
    return ok;
  };

  return (
    <div ref={wurzel} style={hoehe ? { height: hoehe } : undefined} className="h-screen w-full max-w-full overflow-hidden flex flex-col bg-background" data-testid="bausteine-fenster">
      <header className="shrink-0 bg-primary text-primary-foreground px-4 py-2.5 flex flex-wrap items-baseline gap-x-3">
        <h1 className="font-semibold">Bausteine</h1>
        <span className="text-sm opacity-90" data-testid="fenster-ziel">
          {ziel ? <>fügt ein in: {ziel.label}</> : "kein Beleg offen – zum Einfügen zuerst einen Beleg öffnen"}
        </span>
      </header>
      <div className="flex-1 min-h-0">
        <BausteineAnsicht modus="fenster" ziel={ziel} onEinfuegen={einfuegen} />
      </div>
    </div>
  );
};

export default BausteineFensterPage;
